import { useMsal } from "@azure/msal-react";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { Button, Divider, Grid } from "@mui/material";
import Collapse from "@mui/material/Collapse";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import { Theme } from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";
import { IdTokenClaims } from "auth/hooks/use-is-in-roles";
import { MODULES_DRAWER_DATA } from "common/constants";
import { env } from "env";
import React, { Fragment, useState } from "react";
import { useHistory } from "react-router-dom";

type DrawerMenuProps = {
  showMenu: boolean;
  setMenu: (state: boolean) => void;
};

const useStyles = makeStyles((theme: Theme) => ({
  list: {
    width: 250,
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
  fullList: {
    width: "auto",
  },
}));

const DrawerMenu: React.FC<DrawerMenuProps> = ({ showMenu, setMenu }) => {
  const history = useHistory();
  const classes = useStyles();
  const { accounts } = useMsal();
  const [openState, setOpenState] = useState<{ [name: string]: boolean }>({
    // Interfaces: false, // Example of an expansible item
  });

  let userRoles = (accounts[0]?.idTokenClaims as IdTokenClaims)?.roles;

  const handleItemClick = (path: string, name: string) => {
    const dropdowns = Object.keys(openState);
    if (dropdowns.includes(name)) {
      setOpenState({ ...openState, [name]: !openState[name] });
    } else {
      history.push(path + history.location.search);
      setMenu(false);
    }
  };

  const ItemMenu = ({
    text,
    to,
    name,
    children,
    index,
    marginLeft = 0,
  }: {
    text: string;
    to: string;
    name: string;
    children: any;
    index: number;
    marginLeft: number;
  }) => {
    return (
      <>
        <ListItem
          style={{ marginLeft: marginLeft }}
          button
          key={index}
          onClick={() => handleItemClick(to, name)}
        >
          <ListItemText primary={text} />
          {children &&
            children.length > 0 &&
            (openState[name] ? <ExpandLess /> : <ExpandMore />)}
        </ListItem>
        {children &&
          children.length > 0 &&
          children.map((item: any, indexChildren: number) => (
            <Collapse in={openState[`${name}`]} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {item.children && item.children.length ? (
                  <ItemMenu
                    text={item.text}
                    name={item.name}
                    children={item.children}
                    index={indexChildren}
                    to={item.to}
                    marginLeft={10}
                  />
                ) : (
                  <ListItem
                    style={{ marginLeft: 10 + marginLeft }}
                    button
                    key={index}
                    onClick={() => handleItemClick(item.to, item.name)}
                  >
                    <ListItemText primary={item.text} />
                  </ListItem>
                )}
              </List>
            </Collapse>
          ))}
      </>
    );
  };

  return (
    <div>
      <Fragment>
        <Drawer anchor="left" open={showMenu} onClose={() => setMenu(false)}>
          <div
            className={classes.list}
            role="presentation"
            onKeyDown={() => setMenu(false)}
          >
            <List>
              {MODULES_DRAWER_DATA.map(
                ({ text, to, name, children }, index) => {
                  return (
                    <ItemMenu
                      key={index}
                      text={text}
                      to={to}
                      name={name}
                      children={children}
                      index={index}
                      marginLeft={0}
                    />
                  );
                }
              )}
            </List>
          </div>
          {userRoles?.includes("Admin.Manage") && (
            <Grid
              container
              spacing={2}
              justifyContent="center"
              alignItems="center"
            >
              <Grid item xs={12}>
                <Divider variant="fullWidth" />
              </Grid>
              <Grid item>
                <Button
                  variant="text"
                  color="primary"
                  href={env.REACT_APP_ADMIN_URL + history.location.search}
                >
                  Admin App
                </Button>
              </Grid>
            </Grid>
          )}
        </Drawer>
      </Fragment>
    </div>
  );
};

export default DrawerMenu;
